module.exports = __webpack_public_path__ + "static/img/b5_footer.50643c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b5_footer.png
// module id = bD14
// module chunks = 1